module.exports = __webpack_public_path__ + "img/integral-banner.6edfcada.png";